import PropTypes from "prop-types";
import React from "react";
import { PageAlert } from "ui/alert/page-alert";

class AdPlatformSyncedAlert extends React.PureComponent {
  static get propTypes() {
    return {
      objectName: PropTypes.string.isRequired,
    };
  }

  render() {
    const { objectName } = this.props;

    return (
      <PageAlert>
        This {objectName} is synced with the Ad Platform, therefore certain
        fields will not be editable.
      </PageAlert>
    );
  }
}

export { AdPlatformSyncedAlert };
